import styled from 'styled-components';

const MortgageCalcContainer = styled.div``;

const ErrorText = styled.p<{ broker?: boolean }>`
  color: ${({ theme, broker }) => (broker ? theme.textDark : theme.white)};
  margin-top: 65px;
  max-width: 88%;
  font-weight: 600;
  margin: auto;
  text-align: center;
  padding-top: ${({ broker }) => (broker ? '0px' : '50px')};
`;

export { ErrorText, MortgageCalcContainer };
